<template>
    <div class="timeline">
      <Home/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import Home from '@/components/RequestTimeline.vue'
  
  export default {
    name: 'timeline-view',
    components: {
      Home
    }
  }
  </script>
  